import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableauDeBordComponent } from './tableau-de-bord/tableau-de-bord.component';
import { AppRoutingModule } from '../../app-routing.module';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    declarations: [TableauDeBordComponent],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        SharedModule,
    ],
    exports: [
        TableauDeBordComponent,
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
    ],
})
export class EspaceClientModule {}
